import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {getColor} from '../../styles/utils';
import {Text as UIText} from '../../uikit/Text';
import {View} from '../../uikit/View';
import {platform} from '../../utils/platform';

export const Container = styled(View)<StyledProps>`
  display: flex;
  flex-direction: row;

  ${p =>
    p.disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`;

export const Text = styled(UIText)`
  display: ${platform.isNative ? 'flex' : 'block'};
`;

export const ButtonText = styled(Text).attrs({weight: 'semibold'})`
  color: ${getColor('text.primary')};
`;
